import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { HorseMark } from '@/components/brand/horse-mark'
import { siteConfig } from '@/constants/site'

interface WordmarkProps {
    href?: string
    className?: string
    label?: string
}

export const Wordmark: FC<WordmarkProps> = ({ href = '/', className, label = `${siteConfig.name}, về trang chủ` }): ReactNode => {
    return (
        <Link href={href} aria-label={label} className={cn('inline-flex items-center gap-2.5 font-heading text-xl font-semibold tracking-[-0.06em] text-foreground', className)}>
            <HorseMark className='size-[1.45em]' />

            <span aria-hidden='true'>
                horse<span className='text-lime'>moon</span>
            </span>
        </Link>
    )
}
